import { DataTypeProvider } from '@devexpress/dx-react-grid';
import NRHCPVerification from '../../../NRHCPVerification/NRHCPVerification';

const VerificationFormatter = ({ value }) => {
  return <NRHCPVerification verification={value} />;
};
export const NRVerificationProvider = props => <DataTypeProvider formatterComponent={VerificationFormatter} {...props} />;
